import { render } from "./ActualProposalModal.vue?vue&type=template&id=06a6fdd9"
import script from "./ActualProposalModal.vue?vue&type=script&lang=js"
export * from "./ActualProposalModal.vue?vue&type=script&lang=js"

import "./ActualProposalModal.vue?vue&type=style&index=0&id=06a6fdd9&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__